import React from 'react';
export const Documents = () => (
  <svg width="201px" height="160px" viewBox="0 0 201 160" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-1302.000000, -992.000000)">
        <path
          d="M1450.56983,1146 L1354.43037,1146 L1302.50857,1093.96124 C1301.83048,1093.28162 1301.83048,1092.16961 1302.50857,1091.48999 L1401.26703,992.509056 C1401.946,991.830315 1403.05466,991.830315 1403.73275,992.509056 L1502.49208,1091.48999 C1503.16931,1092.16961 1503.16931,1093.28162 1502.49208,1093.96124 L1450.56983,1146 Z"
          fill="#F3F4F6"
          fillRule="nonzero"
        />
        <path
          d="M1478,1145 L1446,1145"
          stroke="#EB1D26"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1359,1145 L1340,1145"
          stroke="#EB1D26"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1330,1145 L1322,1145"
          stroke="#EB1D26"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1421,1148.00053 C1421,1150.20903 1413.61294,1152 1404.4995,1152 C1395.38706,1152 1388,1150.20903 1388,1148.00053 C1388,1145.79097 1395.38706,1144 1404.4995,1144 C1413.61294,1144 1421,1145.79097 1421,1148.00053"
          fill="#D0D7DA"
        />
        <polygon
          fill="#E2E8EE"
          points="1435 1109.23673 1384.4411 1118 1380 1078.53246 1397.58631 1075.48446 1398.05053 1078.5971 1430.3448 1073"
        />
        <polygon
          stroke="#7350A0"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="1435 1109.23673 1384.4411 1118 1380 1078.53246 1397.58631 1075.48446 1398.05053 1078.5971 1430.3448 1073"
        />
        <g transform="translate(1406.000000, 1053.000000)">
          <polyline
            fill="#FCFCFC"
            points="3.002 10.4847 4.248 0.0467 32.755 3.4497 28.519 38.9277 0.012 35.5247 2.373 15.7517"
          />
          <polyline
            stroke="#0B9CE5"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="3.002 10.4847 4.248 0.0467 32.755 3.4497 28.519 38.9277 0.012 35.5247 2.373 15.7517"
          />
        </g>
        <path
          d="M1414,1067 L1433,1069"
          stroke="#E2E8EE"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M1414,1060 L1420,1060.74"
          stroke="#E2E8EE"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M1413,1071 L1432,1073"
          stroke="#E2E8EE"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M1413,1076 L1432,1078"
          stroke="#E2E8EE"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M1412,1080 L1421,1081"
          stroke="#E2E8EE"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M1431.40739,1055.99025 L1431.46579,1055.5391 C1431.587,1054.59159 1432.47846,1053.90408 1433.44596,1054.01095 C1434.41455,1054.11989 1435.10656,1054.98313 1434.98645,1055.93064 L1434.53356,1059.46173 C1434.41235,1060.40924 1433.52089,1061.09675 1432.55339,1060.98885 C1431.5848,1060.88197 1430.89168,1060.0177 1431.014,1059.06916"
          stroke="#042F43"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <polygon
          fill="#FCFCFC"
          points="1416 1090.62497 1395.32337 1095 1390 1069.34372 1405.80523 1066 1411.55773 1069.98779"
        />
        <polygon
          stroke="#D71385"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="1416 1090.62497 1395.32337 1095 1390 1069.34372 1405.80523 1066 1411.55773 1069.98779"
        />
        <path
          d="M1408.20465,1079.50097 L1396.73559,1081.97781 C1396.19397,1082.09451 1395.66312,1081.73938 1395.5495,1081.18305 L1394.0216,1073.71632 C1393.90799,1073.16099 1394.25373,1072.61573 1394.79535,1072.49903 L1406.26441,1070.02219 C1406.80603,1069.90549 1407.33688,1070.26062 1407.44952,1070.81695 L1408.9784,1078.28368 C1409.09201,1078.83901 1408.74627,1079.38427 1408.20465,1079.50097"
          fill="#E2E8EE"
        />
        <g transform="translate(1374.000000, 1078.000000)">
          <polyline
            fill="#FCFCFC"
            points="3.5103 18.1312 0.8853 9.3192 53.1023 0.3542 60.3193 30.5182 9.7833 39.1942 4.9853 23.0832"
          />
          <polyline
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="3.5103 18.1312 0.8853 9.3192 53.1023 0.3542 60.3193 30.5182 9.7833 39.1942 4.9853 23.0832"
          />
        </g>
        <polyline
          stroke="#D71385"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="1406 1066 1407.12817 1071 1412 1069.90333"
        />
        <path
          d="M1382,1043 L1382,1044"
          stroke="#0B9CE5"
          strokeLinecap="round"
        />
        <path
          d="M1382,1047 L1382,1048"
          stroke="#0B9CE5"
          strokeLinecap="round"
        />
        <path
          d="M1385,1046 L1384,1046"
          stroke="#0B9CE5"
          strokeLinecap="round"
        />
        <path
          d="M1381,1046 L1380,1046"
          stroke="#0B9CE5"
          strokeLinecap="round"
        />
        <path
          d="M1450,1085 L1450,1086"
          stroke="#D62793"
          strokeLinecap="round"
        />
        <path
          d="M1450,1089 L1450,1090"
          stroke="#D62793"
          strokeLinecap="round"
        />
        <path
          d="M1453,1088 L1452,1088"
          stroke="#D62793"
          strokeLinecap="round"
        />
        <path
          d="M1449,1088 L1448,1088"
          stroke="#D62793"
          strokeLinecap="round"
        />
        <path
          d="M1393,1052 C1393,1052.55149 1392.55149,1053 1392,1053 C1391.44737,1053 1391,1052.55149 1391,1052 C1391,1051.44851 1391.44737,1051 1392,1051 C1392.55149,1051 1393,1051.44851 1393,1052"
          fill="#D62793"
        />
        <path
          d="M1444,1096.99943 C1444,1097.55238 1443.55263,1098 1443,1098 C1442.44851,1098 1442,1097.55238 1442,1096.99943 C1442,1096.44762 1442.44851,1096 1443,1096 C1443.55263,1096 1444,1096.44762 1444,1096.99943"
          fill="#AA81F7"
        />
        <polyline
          stroke="#AA81F7"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="1363 1068 1367.49952 1063 1372 1068"
        />
        <path
          d="M1367,1063 L1367,1076"
          stroke="#AA81F7"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1367,1080 L1367,1098"
          stroke="#C3D3D8"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeDasharray="3,6"
        />
      </g>
    </g>
  </svg>
);
